(function () {

  const sections =
    document.querySelectorAll(
      '[data-kcar-product-details]'
    );


  if (!sections.length) {
    return;
  }


  sections.forEach(
    initKCarProductDetails
  );


  function initKCarProductDetails(root) {

    /*
     * 先给 Vehicle Fitment 排序。
     *
     * 排序规则：
     * 1. Make
     * 2. Model
     * 3. Year
     */
    sortVehicleFitments(root);


    /*
     * 初始化顶部导航。
     */
    initNavigation(root);


    /*
     * 初始化 Fitment 搜索。
     */
    initFitmentSearch(root);

  }



  /* ========================================================
     VEHICLE FITMENT SORT
     ======================================================== */

  function sortVehicleFitments(root) {

    const table =
      root.querySelector(
        '[data-kcar-fitment-table]'
      );


    if (!table) {
      return;
    }


    const tbody =
      table.querySelector('tbody');


    if (!tbody) {
      return;
    }


    const rows =
      Array.from(
        tbody.querySelectorAll(
          '[data-kcar-fitment-row]'
        )
      );


    if (rows.length < 2) {
      return;
    }


    /*
     * 对每一行进行排序。
     */
    rows.sort(function (rowA, rowB) {

      const makeA =
        normalizeSortText(
          rowA.dataset.fitmentMake
        );

      const makeB =
        normalizeSortText(
          rowB.dataset.fitmentMake
        );


      const modelA =
        normalizeSortText(
          rowA.dataset.fitmentModel
        );

      const modelB =
        normalizeSortText(
          rowB.dataset.fitmentModel
        );


      const yearA =
        getStartYear(
          rowA.dataset.fitmentYear
        );

      const yearB =
        getStartYear(
          rowB.dataset.fitmentYear
        );


      /*
       * 第一层：
       * Make 排序。
       *
       * 例如：
       * Hyundai
       * Kia
       */
      const makeCompare =
        makeA.localeCompare(
          makeB,
          'en',
          {
            sensitivity: 'base',
            numeric: true
          }
        );


      if (makeCompare !== 0) {
        return makeCompare;
      }


      /*
       * 第二层：
       * 同一个 Make 下面按照 Model 排序。
       */
      const modelCompare =
        modelA.localeCompare(
          modelB,
          'en',
          {
            sensitivity: 'base',
            numeric: true
          }
        );


      if (modelCompare !== 0) {
        return modelCompare;
      }


      /*
       * 第三层：
       * 同车型有多个年份时，
       * 按起始年份从早到晚排列。
       */
      if (yearA !== yearB) {
        return yearA - yearB;
      }


      /*
       * 如果 Make / Model / Year
       * 全部一样，
       * 保持原始后台顺序。
       */
      return (
        Number(
          rowA.dataset.fitmentOriginalOrder || 0
        )
        -
        Number(
          rowB.dataset.fitmentOriginalOrder || 0
        )
      );

    });


    /*
     * 把排序完成后的行
     * 重新放回 tbody。
     */
    rows.forEach(function (row) {
      tbody.appendChild(row);
    });

  }



  /*
   * 排序文字标准化。
   *
   * Kia / kia / KIA
   * 都会按照相同逻辑处理。
   */
  function normalizeSortText(value) {

    return String(
      value || ''
    )
      .trim()
      .replace(/\s+/g, ' ');

  }



  /*
   * 从年份字符串里读取第一个四位年份。
   *
   * 例如：
   *
   * 2009–2019 → 2009
   * 2017-present → 2017
   * 2011-2018 → 2011
   */
  function getStartYear(value) {

    const text =
      String(
        value || ''
      );


    const match =
      text.match(/\b(19|20)\d{2}\b/);


    if (!match) {

      /*
       * 如果没有年份，
       * 自动排到最后。
       */
      return 9999;

    }


    return Number(
      match[0]
    );

  }



  /* ========================================================
     STICKY NAVIGATION
     ======================================================== */

  function initNavigation(root) {

    const tabs =
      Array.from(
        root.querySelectorAll(
          '.kcar-tab'
        )
      );


    const contentSections =
      Array.from(
        root.querySelectorAll(
          '[data-kcar-section]'
        )
      );


    if (
      !tabs.length ||
      !contentSections.length
    ) {
      return;
    }


    tabs.forEach(function (tab) {

      tab.addEventListener(
        'click',
        function (event) {

          const targetId =
            tab.getAttribute('href');


          if (
            !targetId ||
            !targetId.startsWith('#')
          ) {
            return;
          }


          const target =
            root.querySelector(
              targetId
            );


          if (!target) {
            return;
          }


          event.preventDefault();


          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });


          setActiveTab(tab);

        }
      );

    });



    /*
     * 页面滚动时，
     * 自动更新顶部 Tab 的选中状态。
     */
    const observer =
      new IntersectionObserver(

        function (entries) {

          const visibleEntries =
            entries
              .filter(
                function (entry) {
                  return entry.isIntersecting;
                }
              )
              .sort(
                function (a, b) {

                  return (
                    Math.abs(
                      a.boundingClientRect.top
                    )
                    -
                    Math.abs(
                      b.boundingClientRect.top
                    )
                  );

                }
              );


          if (!visibleEntries.length) {
            return;
          }


          const currentSection =
            visibleEntries[0].target;


          const matchingTab =
            tabs.find(
              function (tab) {

                return (
                  tab.getAttribute('href')
                  ===
                  '#' + currentSection.id
                );

              }
            );


          if (matchingTab) {
            setActiveTab(
              matchingTab
            );
          }

        },

        {
          root: null,

          rootMargin:
            '-25% 0px -60% 0px',

          threshold: 0
        }

      );


    contentSections.forEach(
      function (section) {

        observer.observe(
          section
        );

      }
    );



    function setActiveTab(activeTab) {

      tabs.forEach(
        function (tab) {

          tab.classList.toggle(
            'is-active',
            tab === activeTab
          );

        }
      );

    }

  }



  /* ========================================================
     VEHICLE FITMENT SEARCH
     ======================================================== */

  function initFitmentSearch(root) {

    const searchInput =
      root.querySelector(
        '[data-kcar-fitment-search]'
      );


    const rows =
      Array.from(
        root.querySelectorAll(
          '[data-kcar-fitment-row]'
        )
      );


    const noResults =
      root.querySelector(
        '[data-kcar-no-results]'
      );


    /*
     * ≤8 个 Fitment 时，
     * 页面没有搜索框。
     * 这种情况直接结束即可。
     */
    if (
      !searchInput ||
      !rows.length
    ) {
      return;
    }


    searchInput.addEventListener(
      'input',
      function () {

        const query =
          normalizeSearchText(
            searchInput.value
          );


        let matches = 0;


        rows.forEach(
          function (row) {

            const rowText =
              normalizeSearchText(
                row.textContent
              );


            const visible =
              !query ||
              rowText.includes(
                query
              );


            row.hidden =
              !visible;


            if (visible) {
              matches++;
            }

          }
        );


        if (noResults) {

          noResults.hidden =
            matches !== 0;

        }

      }
    );

  }



  /*
   * Search 文本标准化。
   */
  function normalizeSearchText(value) {

    return String(
      value || ''
    )
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

  }

})();